import S3 from 'react-aws-s3';
import { toast } from 'react-toastify';

const toastConfig = {
  position: 'top-right',
  autoClose: 2500,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export const notify = (type, message) => {
  switch (true) {
    case type === 'error':
      toast.error(message, toastConfig);
      break;
    case type === 'warn':
      toast.warn(message, toastConfig);
      break;
    case type === 'success':
    default:
      toast.success(message, toastConfig);
      break;
  }
};

export const noop = () => {};
export const replaceVideoScripts = (html) => {
  let str = html;
  str = html.replace(/”/g, '"');

  // replace video scripts
  let idx = str.indexOf('[video id="');

  while (idx !== -1) {
    const endIdx = str.indexOf(']', idx);
    if (endIdx === -1) {
      return str;
    }

    // search video id
    const idStartIdx = str.indexOf('"', idx);
    const idEndIdx = str.indexOf('"', idStartIdx + 1);
    if (idStartIdx === -1 || idEndIdx === -1) {
      return str;
    }
    const videoId = str.slice(idStartIdx + 1, idEndIdx);

    const titleStartId = str.indexOf('title="', idEndIdx + 1);
    const titleEndId = str.indexOf('"', titleStartId + 7);
    if (titleStartId === -1 || titleEndId === -1) {
      return str;
    }
    const videoTitle = str.slice(titleStartId + 7, titleEndId);
    const videoScript = str.slice(idx, endIdx + 1);

    str = str.replace(
      videoScript,
      `<div class="wistia_responsive_padding" style="margin: 20px 0px;padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><iframe src="https://fast.wistia.net/embed/iframe/${videoId}?videoFoam=true" title="${videoTitle}" allow="autoplay; fullscreen" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" allowfullscreen msallowfullscreen width="100%" height="100%"></iframe></div></div>	
  <script src="https://fast.wistia.net/assets/external/E-v1.js" async></script>`
    );
    idx = str.indexOf('[video id="', idx + 1);
  }

  return str;
};

export const replaceOptInButton = (html, optedIn) => {
  let str = html;
  str = html.replace(/”/g, '"');

  const className =
    'btn text-white font-bold bg-light-yellow rounded-lg px-4 py-2 text-base complete-btn ' +
    ((optedIn && 'btn-secondary') || '');

  str = str.replace(
    '[opt-in button]',
    `<button id="opt-in-btn" class="${className}">${
      optedIn ? 'Added' : 'Opt-In'
    }</button>`
  );

  return str;
};

export const isInProgress = (curriculum, progress) => {
  const { courses } = curriculum;
  return progress.some(
    ({ course, completedLessons, completedQuizzes }) =>
      course &&
      courses.some(({ _id }) => _id === course._id) &&
      (completedLessons.length || completedQuizzes.length)
  );
};

export const spliceString = (str, index, count, add) => {
  if (index < 0) {
    index = str.length + index;
    if (index < 0) {
      index = 0;
    }
  }

  return str.slice(0, index) + (add || '') + str.slice(index + count);
};

export const uploadToS3 = async (file, dir = '', newFilename) => {
  const config = {
    bucketName: process.env.REACT_APP_BUCKET_NAME,
    dirName: dir || 'post-attachments',
    region: process.env.REACT_APP_REGION,
    accessKeyId: process.env.REACT_APP_ACCESS_ID,
    secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
  };

  const ReactS3Client = new S3(config);
  const res = await ReactS3Client.uploadFile(file, newFilename);
  return res;
};

export const getFullPathToS3 = (key, dir = '') =>
  `https://${process.env.REACT_APP_BUCKET_NAME}.s3-${
    process.env.REACT_APP_REGION
  }.amazonaws.com/${dir || 'post-attachments'}/${key}`;

export const parseJwt = (token) => {
  if (!token || !token.includes('.')) {
    return {};
  }

  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
};

export const isAuthed = () => {
  const token = localStorage.getItem('authToken');
  const payload = parseJwt(token);

  if (payload.exp > Date.now() / 1000) {
    return true;
  }

  return false;
};

export function convertToCSV(objArray) {
  var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
  var str = '';

  for (var i = 0; i < array.length; i++) {
    var line = '';
    for (var index in array[i]) {
      if (line != '') line += ',';

      line += array[i][index];
    }

    str += line + '\r\n';
  }

  return str;
}

export function exportCSVFile(csvContent, fileTitle) {
  var csv = convertToCSV(csvContent);

  var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

  var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, exportedFilenmae);
  } else {
    var link = document.createElement('a');
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', exportedFilenmae);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}

export function isAlphaNumeric(c) {
  if (!c) return false;

  const regex = new RegExp(/^[a-z0-9]+$/i);
  return regex.test(c);
}

export function getSourceUrls(text) {
  const urls = [];

  const sources = text.split('src=');
  sources.forEach((str, i) => {
    if (i === 0) return;

    const src = str.split(/[ >]/)[0];
    if (src) {
      const domain = src.split('https://')[1].split(/[ /]/)[0];
      urls.push(domain);
    }
  });

  return urls;
}

const validVideoDomains = ['youtube.com', 'loom.com', 'wistia.net'];

export function isUntrustedVideoScript(video) {
  const domains = (video && getSourceUrls(video)) || [];
  const isInValid = domains.some((domain) => {
    const valid = validVideoDomains.some(
      (dom) => (domain.toLowerCase() + 'a').split(dom)[1] === 'a'
    );

    return !valid;
  });

  return isInValid;
}
